const canRestoreFocus = (invoker: HTMLElement | null): invoker is HTMLElement =>
  invoker !== null &&
  invoker !== document.body &&
  invoker !== document.documentElement &&
  invoker.isConnected &&
  !invoker.hidden &&
  !invoker.matches(":disabled, [aria-hidden='true']");

export const restoreAssistantActionFocus = (invoker: HTMLElement | null, requestComposerFocus: () => void): void => {
  requestAnimationFrame(() => {
    if (canRestoreFocus(invoker)) {
      invoker.focus();
      if (document.activeElement === invoker) {
        return;
      }
    }
    requestComposerFocus();
  });
};
